export default "__VITE_ASSET__6CliRiqz__"